import axios from 'axios';

export default {
  formats: (params = {}, config = {}) => axios.get('exports/formats', { params, ...config }),
  deleteFormat: (formatId, config = {}) => axios.delete(`exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  exportPdf: (payload = {}, config = {}) => axios.post('exports/pdf', payload, {
    responseType: 'blob',
    ...config,
  }),
};
